<template>
  <div>
    <div class="container" v-if="isShow">
      <!-- 基本信息 -->
      <div class="card">
        <div class="title">
          <!-- <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg> -->
          <van-icon name="qr" size="26" color="#1989fa" />
          <span style="flex: 1">{{qrCodeInfo.contractName}}</span>
          <van-tag round :type="styleArr[qrCodeInfo.payStatus]">{{ qrCodeInfo.payStatus == 0?'未支付':'已支付' }}</van-tag>
        </div>
        <van-tabs v-model="active">
          <van-tab title="订单信息">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">订单编号：</span>
                <span class="value">{{ qrCodeInfo.payOrderNum }}</span>
              </div>
              <div class="item" >
                <span class="key">商品名称：</span>
                <span class="value">{{ qrCodeInfo.payOrderName }}</span>
              </div>
              <div class="item" >
                <span class="key">支付金额(元)：</span>
                <span class="value" style="color: #ee0a24 !important;">￥{{ qrCodeInfo.payMoney }}</span>
              </div>
              <div class="item" v-if="qrCodeInfo.payStatus == 1">
                <span class="key">退款状态：</span>
                <span class="value">
                  <span v-if="qrCodeInfo.refundType == 0">全额退款</span>
                  <span v-if="qrCodeInfo.refundType == 1">部分退款</span>
                  <span v-if="qrCodeInfo.refundType == 2">未退款</span>
                </span>
              </div>
              <div class="item" v-if="qrCodeInfo.payStatus == 0">
                <span class="key">支付二维码：</span>
                <van-button type="info" size="mini" plain @click="handleQrcode()" v-if="qrCodeInfo.qrcodeUrl">点击查看</van-button>
                <span class="value" v-else>无</span>
                <!-- <span class="value">{{qrCodeInfo.payImg}}</span> -->
              </div>
              <div class="item">
                <span class="key">订单客户信息：</span>
                <span class="value"><span style="color: #1989fa;margin-right: 5px;">{{qrCodeInfo.custName}}</span>{{qrCodeInfo.mobile}}</span>
              </div>
              <div class="item">
                <span class="key">部门/申请人：</span>
                <span class="value">{{qrCodeInfo.deptName}}<span style="color: #1989fa;margin-left: 5px;">{{qrCodeInfo.userName}}</span></span>
              </div>
              <div class="item" >
                <span class="key">创建时间：</span>
                <span class="value">{{ qrCodeInfo.createTime }}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="退款记录" v-if="qrCodeInfo.refundType != 2">
            <empty v-if="refundRecordList.length == 0" />
            <van-list :finished="finished" finished-text="没有更多了" v-if="refundRecordList.length > 0">
              <van-cell v-for="(item,index) in refundRecordList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div style="max-width: 100%">
                    <div>
                      <span class="key"> 退款订单编号：</span>
                      <span class="value">{{ item.refundOrderNum }}</span>
                    </div>
                    <div>
                      <span class="key"> 支付交易流水号：</span>
                      <span class="value">{{ item.thirdOrderNo }}</span>
                    </div>
                    <div>
                      <span class="key"> 退款交易流水号：</span>
                      <span class="value">{{ item.refundPayNo }}</span>
                    </div>
                    <div>
                      <span class="key"> 微信退款单号：</span>
                      <span class="value">{{ item.wxRefundId }}</span>
                    </div>
                    <div>
                      <span class="key"> 退款金额(元)：</span>
                      <span class="value" style="color: #ee0a24 !important;">{{ item.price }}</span>
                    </div>
                    <div>
                      <span class="key"> 退款原因：</span>
                      <span class="value">{{ item.reason }}</span>
                    </div>
                    <div>
                      <span class="key"> 实际退款时间：</span>
                      <span class="value">{{ item.actualTime }}</span>
                    </div>
                    <div>
                      <span class="key"> 退款类型：</span>
                      <span class="value">{{ item.refundType == 0?'全部退款':'部分退款' }}</span>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </van-tab>
          <!-- <van-tab title="操作日志">
            <div class="item">
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in operationLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <div v-for="(val,label) in item.listData" :key="label">
                    <div class="contLogSp">
                      <div>
                        <van-image style="width: 0.6rem; height: 0.6rem" :src="val.avatar" ></van-image>
                        <span style="margin-left: 10px;">{{val.userName}}</span>
                      </div>
                      <div>
                        <van-tag size="mini" :type="val.spStatus == 2?'success':val.spStatus == 3?'danger':'warning'">{{val.spStatus == 2?'已通过':val.spStatus == 3?'驳回':'审批中'}}</van-tag>
                        <span></span>
                        <span v-if="val.spTime" style="margin-left: 10px;">{{val.spTime}}</span>
                      </div>
                    </div>
                    <div v-if="val.spComment">{{val.spComment}}</div>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </van-tab> -->
          <van-tab title="合同信息">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">合同名称：</span>
                <span class="value">{{ contForm.contractName }}</span>
              </div>
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ contForm.contractNum }}</span>
              </div>
              <div class="item" >
                <span class="key">执行时间：</span>
                <span class="value">{{ contForm.startTime }}至{{ contForm.endTime }}</span>
              </div>
              <div class="item" >
                <span class="key">收款单位：</span>
                <span class="value">{{contForm.companyName}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">垫款方式：</span>
                <span class="value">{{formatHandel('payType',contForm.payType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">框架类型：</span>
                <span class="value">{{formatHandel('frameType',contForm.frameType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">客户来源：</span>
                <span class="value">{{formatHandel('custSource',contForm.custSource)}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="合同项目" v-if="contForm.businessTypeName?contForm.businessTypeName.indexOf('品牌推广') == -1 && contForm.businessTypeName.indexOf('数字技术') == -1:false">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">开户服务费（元）：</span>
                <span class="value">{{contForm.openAccountFee || '-'}}</span>
              </div>
              <div class="item" >
                <span class="key">代运营服务费：</span>
                <span class="value">{{contForm.agentBussFee || '-'}}%</span>
              </div>
              <div class="item" >
                <span class="key">素材费（元）：</span>
                <span class="value">{{contForm.materialMoney || '-'}}</span>
              </div>
            </div>
            <div v-if="pointList.length == 0" style="text-align: center">暂无返点数据</div>
            <van-list :finished="finished" finished-text="没有更多了" v-if="pointList.length > 0">
              <van-cell v-for="(item,index) in pointList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div style="max-width: 80%">
                    <div>
                      <span class="key"> 返点百分比值(%)：</span>
                      <span class="value">{{ item.percentage }}%</span>
                    </div>
                    <div>
                      <span class="key"> 返点消耗(元)：</span>
                      <span class="value">{{ item.useMoney }}(元)</span>
                    </div>
                    <div>
                      <span class="key"> 执行时间：</span>
                      <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </van-tab>
          <van-tab title="合同附件">
            <div class="item">
              <van-list :finished="fileFinished" finished-text="没有更多了"  @load="getContractFileList" v-if="contractFileList.length > 0">
                <van-cell v-for="(item,index) in contractFileList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <div>
                        <span class="key"> 附件类型：</span>
                        <span class="value">{{formatHandel('fileType',item.fileType)}}</span>
                      </div>
                      <div v-if="item.amount">
                        <span class="key"> 合同金额：</span>
                        <span class="value">{{ item.amount }}(元)</span>
                      </div>
                      <div v-if="item.fileDesc">
                        <span class="key"> 附件描述：</span>
                        <span class="value">{{ item.fileDesc }}</span>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction:column;justify-content: space-around">
                      <a :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">附件详情</a>
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="contractFileList.length == 0" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="2" v-if="qrCodeInfo.payStatus == 0">
        <van-grid-item>
          <div class="flex-center" @click="edit">
            <van-icon name="edit" size="22" color="#07c160" />
            <span>修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" @click="close">
            <van-icon name="close" size="22" color="#ee0a24" />
            <span>关闭订单</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" :column-num="1" v-if="qrCodeInfo.payStatus == 0">
        <van-grid-item>
          <div class="flex-center" @click="handleQrcode('generate')">
            <van-icon name="qr" size="22" />
            <span>生成二维码</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- <van-grid class="grid-wrap" :column-num="1" v-if="qrCodeInfo.payStatus == 1 && qrCodeInfo.refundType != 0">
        <van-grid-item>
          <div class="flex-center" >
            <van-icon name="cash-back-record" size="22" color="#ee0a24" />
            <span @click="confirmRefund">确认退款</span>
          </div>
        </van-grid-item>
      </van-grid> -->
      <van-dialog v-model="qrCodeFormShow" title="修改二维码收款" width="95%" style="height:50%" class="nullifyClue" :beforeClose="qrCodeBeforeClose" show-cancel-button>
      <van-form ref="qrCodeForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="qrCodeForm.custName" label="客户名称" type="text" placeholder="请输入客户名称" :rules="[{ required: true }]" required disabled />
          <van-field v-model="qrCodeForm.contactName" label="联系人" type="text" placeholder="请输入联系人" :rules="[{ required: true }]" required />
          <van-field v-model="qrCodeForm.mobile" label="联系人手机号" type="number" placeholder="请输入联系人手机号" :rules="[{ required: true }]" required />
          <van-field v-model="qrCodeForm.payMoney" label="收款金额(元)" type="number" placeholder="请输入收款金额" :rules="[{ required: true }]" required />
        </van-cell-group>
      </van-form>
    </van-dialog>
      <van-dialog v-model="confirmRefundShow" title="确认退款" width="95%" style="height:45%" class="verifyClue" :beforeClose="confirmRefundBeforeClose" show-cancel-button>
        <van-form ref="confirmRefundForm" validate-trigger="onSubmit">
          <van-field v-model="confirmRefundForm.reason" label="退款原因" type="text" placeholder="请输入退款原因" :rules="[{ required: true }]" required />
          <van-field v-model="confirmRefundForm.price" label="退款金额(元)" type="number" placeholder="请输入退款金额" :rules="[{ required: true }]" required />
          <div style="color: #ee0a24;font-size: 14px">提示信息：退款金额不能大于合同收款金额</div>
        </van-form>
      </van-dialog>
      <van-popup
        v-model="qrCodeShow"
        position="bottom"
        :style="{ height: '100%' }"
        close-icon-position="bottom-left"
      >
        <div ref="imageWrapper">
          <img src="../../../assets/images/desktop/qr-head.jpg" alt="" class="qr_head">
          <div class="qr_info">
            <div>商品名称: <span>{{qrCodeInfo.payOrderName}}</span></div>
            <div>客户名称: <span>{{qrCodeInfo.custName}}</span></div>
            <div>支付金额: <span class="pay_money">￥{{qrCodeInfo.payMoney}}</span>元</div>
          </div>
          <div class="qr_main">
            <img src="../../../assets/images/desktop/wx-pay.jpg" alt="" class="wx_pay">
            <!-- <img src="../../../assets/images/desktop/wx-pay.jpg" alt="" class="qr_code"> -->
            <div class="qr_code" ref="qrcode"></div>
            <div class="qr_tip">请扫描二维码进行支付</div>
            <div class="qr_valid_time">支付时效时间:{{qrCodeInfo.overTime}}</div>
            <div class="salesman">业务员:<span>{{qrCodeInfo.userName}}</span><span class="right">电话:<span>{{qrCodeInfo.myMobile}}</span></span></div>
            <div class="qr_bottom">想获客<span>找云赢</span></div>
          </div>
        </div>
        <div class="bottom_tip">保存为图片后可长按分享至微信</div>
        <div class="qr_bottom_btn">
          <van-button size="small" type="warning" @click="qrCodeShow = false">关闭</van-button>
          <van-button size="small" type="info" @click="getImg()">保存为图片</van-button>
        </div>
      </van-popup>
      <van-image-preview v-model="imageShow" :images="imageArr">
        <!-- <template v-slot:index>第{{ index }}页</template> -->
      </van-image-preview>
      <!-- <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup> -->
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import { getDicts } from '@/api/system/dict/data'
import newContract from '@/api/cont/newContract'
import { Toast, Dialog, ImagePreview } from 'vant'
import Empty from '@/components/common/Empty'
import QRCode from 'qrcodejs2'
import html2Canvas from 'html2canvas'
export default {
  components: {
    Empty,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      isShow: false,
      active: 0,
      activeName: '',
      paymentFormShow: false,
      contForm: {},
      pointList: [],
      refundRecordList: [],
      finished: true,
      qrCodeInfo: {},
      qrCodeShow: false,
      artWidth: 375,
      operationLogList: [], // 操作日志
      contractFileList: [], // 合同附件
      fileFinished: true,
      verifyFormShow: false,
      verifyForm: {
        checkStatus: '2',
        checkReason: '',
        contIncomeId: ''
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      styleArr: ['warning', 'success', 'primary', 'danger'],
      options: {
        checkStatusOptions: [],
        frameTypeOptions: [],
        sysMoneyTypeOptions: [],
        checkReasonTypeOptions: [],
        fileTypeOptions: []
      },
      imageShow: false,
      imageArr: [],
      confirmRefundShow: false,
      confirmRefundForm: {
        payOrderId: null,
        reason: null,
        price: null
      },
      qrCodeFormShow: false,
      qrCodeForm: {}
    }
  },
  async created() {
    const { id, active } = this.$route.query
    this.payOrderId = id
    this.activeName = active
    await this.getOptions()
    await this.getQrCode()
    this.getDicts('check_reason_type').then(res => {
      this.options.checkReasonTypeOptions = this.setDictToInt(res)
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 客户来源类型
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 附件类型
    await getDicts('file_type').then(res => {
      this.options.fileTypeOptions = res.data
    })
    await newContract.getContract(this.qrCodeInfo.contractId).then(res => {
      this.contForm = res.data
    })
    await newContract.getRebateList({ contractId: this.qrCodeInfo.contractId }).then(res => {
      this.pointList = res.rows
    })
    if (this.qrCodeInfo.refundType != 2) {
      await payment.listRefund({ payOrderId: this.qrCodeInfo.payOrderId }).then(response => {
        if (response.code === 200) {
          this.refundRecordList = response.rows
        }
      })
    }
    // this.getDicts('sys_money_type').then(res => {
    //   this.options.sysMoneyTypeOptions = this.setDictToInt(res)
    // })
    // this.getLogList()
    this.getContractFileList()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '二维码收款详情'
      // this.getqrCodeInfo()
    },
    async getQrCode(id) {
      const res = await payment.getPayOrde(id || this.$route.query.id)
      if (res.code === 200) {
        this.qrCodeInfo = res.data
        this.isShow = true
      }
    },
    // 修改
    edit() {
      this.qrCodeForm = this.qrCodeInfo
      this.qrCodeFormShow = true
    },
    async qrCodeBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.qrCodeForm.validate()
          await payment.updateQrCode(this.qrCodeForm)
            .then((res) => {
              Toast.success('修改成功')
              this.qrCodeFormShow = false
              setTimeout(() => {
                this.getQrCode()
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.qrCodeFormShow = false
      }
    },
    // 关闭订单
    close() {
      Dialog.confirm({
        message: '是否确认关闭当前二维码订单'
      })
        .then(() => {
          payment.closePay({ payOrderId: this.qrCodeInfo.payOrderId }).then(res => {
            if (res.code == 200) {
              Toast.success('关闭订单成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    // 生成二维码
    handleQrcode(val) {
      this.qrCodeShow = true
      if (val) {
        payment.getQrCode({ payOrderId: this.qrCodeInfo.payOrderId }).then(res => {
          if (res.code == 200) {
            // this.qrCodeLoading = false
            this.showQRcode(res.data.remark)
            this.getQrCode()
          }
        })
        console.log('233')
      } else {
        // this.qrCodeLoading = false
        this.showQRcode(this.qrCodeInfo.remark)
      }
    },
    qrcode(qWidth, qHeight, qText, qRender) {
      const el = this.$refs.qrcode
      new QRCode(el, {
        width: qWidth,
        height: qHeight,
        text: qText,
        render: qRender
      })
    },
    // 获取微信二维码
    showQRcode(params) {
      // 二维码初始化 点击一次添加一个二维码
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = ''
        this.qrcode(180, 185, params, 'canvas')
      }, 200)
    },
    getImg() {
      html2Canvas(this.$refs.imageWrapper, { width: this.artWidth, useCORS: true }).then(canvas => {
        const saveUrl = canvas.toDataURL('image/jpg')
        const aLink = document.createElement('a')
        const blob = this.base64ToBlob(saveUrl)
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true)
        aLink.download = 'qrCode-forPay.png'

        const params = new window.FormData()
        const fileOfBlob = new File([blob], new Date().getTime() + '.jpg')
        params.append('file', fileOfBlob)
        payment.uploadContractFile(params).then(res => {
          if (res.code === 200) {
            // aLink.href = URL.createObjectURL(res.url)
            aLink.href = res.url
            aLink.click()
          }
        })
      })
    },
    base64ToBlob (code) {
      const parts = code.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    },
    // 确认退款
    confirmRefund() {
      this.confirmRefundShow = true
      this.confirmRefundForm.payOrderId = this.qrCodeInfo.payOrderId
      this.confirmRefundForm.price = this.qrCodeInfo.payMoney
    },
    async confirmRefundBeforeClose(type, done) {
      if (type === 'confirm') {
        if (Number(this.confirmRefundForm.price) > Number(this.qrCodeInfo.payMoney)) {
          Toast.fail('退款金额不能大于合同收款金额')
          return done(false)
        }
        try {
          await this.$refs.confirmRefundForm.validate()
          payment.addRefund(this.confirmRefundForm).then(response => {
            if (response.code == 200) {
              this.confirmRefundShow = false
              Toast.success(response.msg)
              setTimeout(() => {
                this.getQrCode()
              }, 500)
            } else {
              Toast.fail(response.msg)
            }
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.contIncomeId,
        bigType: 2
      }
      newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    // 获取合同附件列表
    async getContractFileList() {
      newContract.listContractFile({ contractId: this.qrCodeInfo.contractId }).then(response => {
        this.contractFileList = response.rows
      })
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'execCustomer') {

      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'

      if (this.picker.formKey === 'contract') {

      } else {
        this.verifyForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.verifyForm[name] = this.options[optionItem][key].dictLabel
      }

      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    // 添加回访记录
    addVisit() {
      this.visitShow = true
    },
    // 添加联系人
    addContacts() {
      this.contactsShow = true
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getOptions() {
      // 审核状态
      this.getDicts('check_status').then(res => {
        this.options.checkStatusOptions = this.setDictToInt(res)
      })
      // 框架类型
      this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = this.setDictToInt(res)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 64%;
}
.nullifyClue /deep/.van-dialog__content {
  height: 68%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/.van-list{
  padding: 0;
}
.qr_head{
  width: 100%;
}
.qr_info{
  margin-top: 20px;
  background-color: #fff;
  padding-left: 140px;
  font-size: 34px;
  line-height: 60px;
  span{
    margin-left: 20px;
  }
  .pay_money{
    color: #ee0a24;
  }
}
.qr_main{
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .wx_pay{
    width: 30%;
  }
  // .qr_code{
  //   margin-top: 10px;
  //   width: 60%;
  //   border: 1px solid #333;
  // }
  .qr_code{
    margin-top: 10px;
    width: 50%;
    border: 1px solid #c4c4c4;
    display: flex;
    justify-content: center;
    padding: 20px;
  }
  .qr_tip{
    padding: 40px 0 20px;
    color: #888;
    font-size: 26px;
  }
  .qr_valid_time{
    color: #888;
    font-size: 26px;
    padding-bottom: 20px;
  }
  .salesman{
    font-size: 32px;
    span{
      margin-left: 10px;
    }
    .right{
      margin-left: 20px;
      span{
        font-size: 34px;
      }
    }
  }
  .qr_bottom{
    padding: 80px 0;
    font-size: 28px;
    span{
      margin-left: 20px;
    }
  }
}
.qr_bottom_btn{
  padding: 20px 100px;
  display: flex;
  justify-content: space-between;
  .van-button{
    width: 40%;
    border-radius: 10px;
  }
}
.bottom_tip{
// display: flex;
// justify-content: flex-end;
padding-left: 100px;
font-size: 28px;
color: #999;
}
</style>
